import { Component, OnInit, HostListener, ViewChild, Output, Input, ElementRef, EventEmitter } from '@angular/core';
import { ThemeService } from '../theme.service';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-slider-runtime',
  templateUrl: './slider-runtime.component.html',
  styleUrls: ['./slider-runtime.component.scss']
})
export class SliderRuntimeComponent extends BaseComponent implements OnInit {

  @Input() title = "";
  @Input() label = "";
  @Input() right: boolean = false;
  @Input() constMinValue: number = 1;
  @Input() constMaxValue: number = 350;
  @Input() alignLeft: boolean = false;

  @Output() selectionChanged = new EventEmitter();

  private _selectedItemsList: string = "";

  @Input() set selectedItemsList(value: string) {
    this._selectedItemsList = value;
    this.choose(this._selectedItemsList);
  }

  get selectedItemsList(): string {
    return this._selectedItemsList;
  }

  public elementRef;
  @ViewChild('dropdownContent', {static: false}) dropdownContent;
  @ViewChild('rangeSlider', {static: false}) rangeSlider;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.closeDropdown();
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  minValue: number = 0;
  maxValue: number = 0;

  constructor(
    myElement: ElementRef,
    private themeService: ThemeService
  ) {
    super();
    this.elementRef = myElement;
   }

  ngOnInit() {
  }

  choose(value: string) {

    if(value) {

      this.minValue = Number(value.split('-')[0]);
      this.maxValue = Number(value.split('-')[1]);

      //update the slider
      if(this.rangeSlider) {
        this.rangeSlider.minValue = this.minValue;
        this.rangeSlider.maxValue = this.maxValue;
      }

      this.selectionChanged.emit(this.minValue + "-" + this.maxValue);
    }

  }

  shouldBeRed(): boolean {
    return this.minValue != this.constMinValue || this.maxValue != this.constMaxValue;
  }

  isOpen(): boolean {
    return this.dropdownContent && this.dropdownContent.nativeElement && this.dropdownContent.nativeElement.classList.contains("dd-open");
  }

  dropdownClick() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      if (this.isOpen()) {
        this.closeDropdown();
      }
      else {
        this.openDropdown();
      }
    }
  }

  openDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-open";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  closeDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-close";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  getSelection(): string {
    if(this.minValue == this.constMinValue && this.maxValue == this.constMaxValue) {
      return this.getString('all');
    }
    return this.minValue + " min - " + this.maxValue + " min";
  }

  reset() {
    this.minValue = this.constMinValue;
    this.maxValue = this.constMaxValue;
    if(this.rangeSlider) {
      this.rangeSlider.minValue = this.minValue;
      this.rangeSlider.maxValue = this.maxValue;
    }
    this.selectionChanged.emit(this.minValue + "-" + this.maxValue);
  }

  rangeSliderChange(values) {
    if(values.min == null || values.max == null) {
      return;
    }
    this.minValue = values.min;
    this.maxValue = values.max;
    this.selectionChanged.emit(this.minValue + "-" + this.maxValue);
  }

}
